export const COLOR_LIST = [
  {
    title: 'Black',
    id: 'Black',
    img: 'https://common.xmslol.com/vooglam/relevant/color/black.png',
  },
  {
    title: 'Tortoise',
    id: 'Tortoise',
    img: 'https://common.xmslol.com/vooglam/relevant/color/tortoiseshell.png',
  },
  {
    title: 'Crystal',
    id: 'Crystal',
    img: 'https://common.xmslol.com/vooglam/relevant/color/transparent.png',
  },
  {
    title: 'Red',
    id: 'Red',
    img: 'https://common.xmslol.com/vooglam/relevant/color/red.png',
  },
  {
    title: 'Floral',
    id: 'Floral',
    img: 'https://common.xmslol.com/vooglam/relevant/color/floral.jpg',
  },
  {
    title: 'Brown',
    id: 'Brown',
    img: 'https://common.xmslol.com/vooglam/relevant/color/brown.png',
  },
  {
    title: 'Two-tone',
    id: 'Two-tone',
    img: 'https://common.xmslol.com/vooglam/relevant/color/two-tone1.jpg',
  },
  {
    title: 'Multicolor',
    id: 'Multicolor',
    img: 'https://common.xmslol.com/vooglam/relevant/color/multicolor.png',
  },
  {
    title: 'Blue',
    id: 'Blue',
    img: 'https://common.xmslol.com/vooglam/relevant/color/blue.png',
  },
  {
    title: 'Purple',
    id: 'Purple',
    img: 'https://common.xmslol.com/vooglam/relevant/color/purple.png',
  },
  {
    title: 'Yellow',
    id: 'Yellow',
    img: 'https://common.xmslol.com/vooglam/relevant/color/yellow.png',
  },
  {
    title: 'Green',
    id: 'Green',
    img: 'https://common.xmslol.com/vooglam/relevant/color/green.png',
  },
  {
    title: 'Gold',
    id: 'Gold',
    img: 'https://common.xmslol.com/vooglam/relevant/color/gold.png',
  },
  {
    title: 'Silver',
    id: 'Silver',
    img: 'https://common.xmslol.com/vooglam/relevant/color/sliver.jpg',
  },
  {
    title: 'Gray',
    id: 'Gray',
    img: 'https://common.xmslol.com/vooglam/relevant/color/gray.png',
  },
  {
    title: 'Pink',
    id: 'Pink',
    img: 'https://common.xmslol.com/vooglam/relevant/color/pink.png',
  },
  {
    title: 'Orange',
    id: 'Orange',
    img: 'https://common.xmslol.com/vooglam/relevant/color/orange.jpg',
  },
  {
    title: 'Champagne',
    id: 'Champagne',
    img: 'https://common.xmslol.com/vooglam/relevant/color/champagne.png',
  },
  {
    title: 'White',
    id: 'White',
    img: 'https://common.xmslol.com/vooglam/relevant/color/white.png',
  },
  {
    title: 'Pattern',
    id: 'Pattern',
    img: 'https://common.xmslol.com/vooglam/relevant/color/pattern.jpg',
  },
  {
    title: 'Animal',
    id: 'Animal',
    img: 'https://common.xmslol.com/vooglam/relevant/color/animal.jpg',
  },
  {
    title: 'Glitter',
    id: 'Glitter',
    img: 'https://common.xmslol.com/vooglam/relevant/color/glitter.jpg',
  },
  {
    title: 'black_blue',
    img: 'https://common.xmslol.com/vooglam/relevant/color-block/two-tone/black_blue.png',
    id: 'black_blue',
  },
  {
    title: 'black_crystal',
    img: 'https://common.xmslol.com/vooglam/relevant/color-block/two-tone/black_crystal.png',
    id: 'black_crystal',
  },
  {
    title: 'black_gold',
    img: 'https://common.xmslol.com/vooglam/relevant/color-block/two-tone/black_gold.png',
    id: 'black_gold',
  },
  {
    title: 'black_grey',
    img: 'https://common.xmslol.com/vooglam/relevant/color-block/two-tone/black_grey.png',
    id: 'black_grey',
  },
  {
    title: 'black_pattern',
    img: 'https://common.xmslol.com/vooglam/relevant/color-block/two-tone/black_pattern.png',
    id: 'black_pattern',
  },
  {
    title: 'black_pink',
    img: 'https://common.xmslol.com/vooglam/relevant/color-block/two-tone/black_pink.png',
    id: 'black_pink',
  },
  {
    title: 'black_red',
    img: 'https://common.xmslol.com/vooglam/relevant/color-block/two-tone/black_red.png',
    id: 'black_red',
  },
  {
    title: 'black_silver',
    img: 'https://common.xmslol.com/vooglam/relevant/color-block/two-tone/black_silver.png',
    id: 'black_silver',
  },
  {
    title: 'black_tortoise',
    img: 'https://common.xmslol.com/vooglam/relevant/color-block/two-tone/black_tortoise.png',
    id: 'black_tortoise',
  },
  {
    title: 'black_white',
    img: 'https://common.xmslol.com/vooglam/relevant/color-block/two-tone/black_white.png',
    id: 'black_white',
  },
  {
    title: 'black_yellow',
    img: 'https://common.xmslol.com/vooglam/relevant/color-block/two-tone/black_yellow.png',
    id: 'black_yellow',
  },
  {
    title: 'blue_animal',
    img: 'https://common.xmslol.com/vooglam/relevant/color-block/two-tone/blue_animal.png',
    id: 'blue_animal',
  },
  {
    title: 'blue_orange',
    img: 'https://common.xmslol.com/vooglam/relevant/color-block/two-tone/blue_orange.png',
    id: 'blue_orange',
  },
  {
    title: 'blue_pattern',
    img: 'https://common.xmslol.com/vooglam/relevant/color-block/two-tone/blue_pattern.png',
    id: 'blue_pattern',
  },
  {
    title: 'blue_purple',
    img: 'https://common.xmslol.com/vooglam/relevant/color-block/two-tone/blue_purple.png',
    id: 'blue_purple',
  },
  {
    title: 'blue_red',
    img: 'https://common.xmslol.com/vooglam/relevant/color-block/two-tone/blue_red.png',
    id: 'blue_red',
  },
  {
    title: 'blue_tortoise',
    img: 'https://common.xmslol.com/vooglam/relevant/color-block/two-tone/blue_tortoise.png',
    id: 'blue_tortoise',
  },
  {
    title: 'blue_white',
    img: 'https://common.xmslol.com/vooglam/relevant/color-block/two-tone/blue_white.png',
    id: 'blue_white',
  },
  {
    title: 'brown_blue',
    img: 'https://common.xmslol.com/vooglam/relevant/color-block/two-tone/brown_blue.png',
    id: 'brown_blue',
  },
  {
    title: 'brown_floral',
    img: 'https://common.xmslol.com/vooglam/relevant/color-block/two-tone/brown_floral.png',
    id: 'brown_floral',
  },
  {
    title: 'brown_pattern',
    img: 'https://common.xmslol.com/vooglam/relevant/color-block/two-tone/brown_pattern.png',
    id: 'brown_pattern',
  },
  {
    title: 'brown_tortoise',
    img: 'https://common.xmslol.com/vooglam/relevant/color-block/two-tone/brown_tortoise.png',
    id: 'brown_tortoise',
  },
  {
    title: 'brown_yellow',
    img: 'https://common.xmslol.com/vooglam/relevant/color-block/two-tone/brown_yellow.png',
    id: 'brown_yellow',
  },
  {
    title: 'gold_white',
    img: 'https://common.xmslol.com/vooglam/relevant/color-block/two-tone/gold_white.png',
    id: 'gold_white',
  },
  {
    title: 'green_black',
    img: 'https://common.xmslol.com/vooglam/relevant/color-block/two-tone/green_black.png',
    id: 'green_black',
  },
  {
    title: 'green_floral',
    img: 'https://common.xmslol.com/vooglam/relevant/color-block/two-tone/green_floral.png',
    id: 'green_floral',
  },
  {
    title: 'green_gold',
    img: 'https://common.xmslol.com/vooglam/relevant/color-block/two-tone/green_gold.png',
    id: 'green_gold',
  },
  {
    title: 'green_pink',
    img: 'https://common.xmslol.com/vooglam/relevant/color-block/two-tone/green_pink.png',
    id: 'green_pink',
  },
  {
    title: 'green_red',
    img: 'https://common.xmslol.com/vooglam/relevant/color-block/two-tone/green_red.png',
    id: 'green_red',
  },
  {
    title: 'green_tortoise',
    img: 'https://common.xmslol.com/vooglam/relevant/color-block/two-tone/green_tortoise.png',
    id: 'green_tortoise',
  },
  {
    title: 'green_yellow',
    img: 'https://common.xmslol.com/vooglam/relevant/color-block/two-tone/green_yellow.png',
    id: 'green_yellow',
  },
  {
    title: 'grey_tortoise',
    img: 'https://common.xmslol.com/vooglam/relevant/color-block/two-tone/grey_tortoise.png',
    id: 'grey_tortoise',
  },
  {
    title: 'orange_grey',
    img: 'https://common.xmslol.com/vooglam/relevant/color-block/two-tone/orange_grey.png',
    id: 'orange_grey',
  },
  {
    title: 'orange_tortoise',
    img: 'https://common.xmslol.com/vooglam/relevant/color-block/two-tone/orange_tortoise.png',
    id: 'orange_tortoise',
  },
  {
    title: 'pink_blue',
    img: 'https://common.xmslol.com/vooglam/relevant/color-block/two-tone/pink_blue.png',
    id: 'pink_blue',
  },
  {
    title: 'pink_floral',
    img: 'https://common.xmslol.com/vooglam/relevant/color-block/two-tone/pink_floral.png',
    id: 'pink_floral',
  },
  {
    title: 'pink_pattern',
    img: 'https://common.xmslol.com/vooglam/relevant/color-block/two-tone/pink_pattern.png',
    id: 'pink_pattern',
  },
  {
    title: 'pink_tortoise',
    img: 'https://common.xmslol.com/vooglam/relevant/color-block/two-tone/pink_tortoise.png',
    id: 'pink_tortoise',
  },
  {
    title: 'purple_black',
    img: 'https://common.xmslol.com/vooglam/relevant/color-block/two-tone/purple_black.png',
    id: 'purple_black',
  },
  {
    title: 'purple_floral',
    img: 'https://common.xmslol.com/vooglam/relevant/color-block/two-tone/purple_floral.png',
    id: 'purple_floral',
  },
  {
    title: 'purple_tortoise',
    img: 'https://common.xmslol.com/vooglam/relevant/color-block/two-tone/purple_tortoise.png',
    id: 'purple_tortoise',
  },
  {
    title: 'red_crystal',
    img: 'https://common.xmslol.com/vooglam/relevant/color-block/two-tone/red_crystal.png',
    id: 'red_crystal',
  },
  {
    title: 'red_pattern',
    img: 'https://common.xmslol.com/vooglam/relevant/color-block/two-tone/red_pattern.png',
    id: 'red_pattern',
  },
  {
    title: 'red_White',
    img: 'https://common.xmslol.com/vooglam/relevant/color-block/two-tone/red_White.png',
    id: 'red_White',
  },
  {
    title: 'silver_crystal',
    img: 'https://common.xmslol.com/vooglam/relevant/color-block/two-tone/silver_crystal.png',
    id: 'silver_crystal',
  },
  {
    title: 'yellow_blue',
    img: 'https://common.xmslol.com/vooglam/relevant/color-block/two-tone/yellow_blue.png',
    id: 'yellow_blue',
  },
  {
    title: 'yellow_crystal',
    img: 'https://common.xmslol.com/vooglam/relevant/color-block/two-tone/yellow_crystal.png',
    id: 'yellow_crystal',
  },
  {
    title: 'yellow_tortoise',
    img: 'https://common.xmslol.com/vooglam/relevant/color-block/two-tone/yellow_tortoise.png',
    id: 'yellow_tortoise',
  },
  {
    title: 'blue_black_crystal',
    img: 'https://common.xmslol.com/vooglam/relevant/color-block/three-tone/blue_black_crystal.png',
    id: 'blue_black_crystal',
  },
  {
    title: 'blue_green_yellow',
    img: 'https://common.xmslol.com/vooglam/relevant/color-block/three-tone/blue_green_yellow.png',
    id: 'blue_green_yellow',
  },
  {
    title: 'blue_purple_orange',
    img: 'https://common.xmslol.com/vooglam/relevant/color-block/three-tone/blue_purple_orange.png',
    id: 'blue_purple_orange',
  },
  {
    title: 'blue_purple_pink',
    img: 'https://common.xmslol.com/vooglam/relevant/color-block/three-tone/blue_purple_pink.png',
    id: 'blue_purple_pink',
  },
  {
    title: 'blue_purple_yellow',
    img: 'https://common.xmslol.com/vooglam/relevant/color-block/three-tone/blue_purple_yellow.png',
    id: 'blue_purple_yellow',
  },
  {
    title: 'brown_black_yellow',
    img: 'https://common.xmslol.com/vooglam/relevant/color-block/three-tone/brown_black_yellow.png',
    id: 'brown_black_yellow',
  },
  {
    title: 'orange_black_blue',
    img: 'https://common.xmslol.com/vooglam/relevant/color-block/three-tone/orange_black_blue.png',
    id: 'orange_black_blue',
  },
  {
    title: 'orange_green_blue',
    img: 'https://common.xmslol.com/vooglam/relevant/color-block/three-tone/orange_green_blue.png',
    id: 'orange_green_blue',
  },
  {
    title: 'pink_blue_black',
    img: 'https://common.xmslol.com/vooglam/relevant/color-block/three-tone/pink_blue_black.png',
    id: 'pink_blue_black',
  },
  {
    title: 'pink_blue_yellow',
    img: 'https://common.xmslol.com/vooglam/relevant/color-block/three-tone/pink_blue_yellow.png',
    id: 'pink_blue_yellow',
  },
  {
    title: 'pink_green_orange',
    img: 'https://common.xmslol.com/vooglam/relevant/color-block/three-tone/pink_green_orange.png',
    id: 'pink_green_orange',
  },
  {
    title: 'pink_green_yellow',
    img: 'https://common.xmslol.com/vooglam/relevant/color-block/three-tone/pink_green_yellow.png',
    id: 'pink_green_yellow',
  },
  {
    title: 'red_black_green',
    img: 'https://common.xmslol.com/vooglam/relevant/color-block/three-tone/red_black_green.png',
    id: 'red_black_green',
  },
  {
    title: 'red_black_yellow',
    img: 'https://common.xmslol.com/vooglam/relevant/color-block/three-tone/red_black_yellow.png',
    id: 'red_black_yellow',
  },
  {
    title: 'red_blue_black',
    img: 'https://common.xmslol.com/vooglam/relevant/color-block/three-tone/red_blue_black.png',
    id: 'red_blue_black',
  },
  {
    title: 'red_blue_brown',
    img: 'https://common.xmslol.com/vooglam/relevant/color-block/three-tone/red_blue_brown.png',
    id: 'red_blue_brown',
  },
  {
    title: 'red_blue_purple',
    img: 'https://common.xmslol.com/vooglam/relevant/color-block/three-tone/red_blue_purple.png',
    id: 'red_blue_purple',
  },
  {
    title: 'red_blue_tortoise',
    img: 'https://common.xmslol.com/vooglam/relevant/color-block/three-tone/red_blue_tortoise.png',
    id: 'red_blue_tortoise',
  },
  {
    title: 'red_blue_yellow',
    img: 'https://common.xmslol.com/vooglam/relevant/color-block/three-tone/red_blue_yellow.png',
    id: 'red_blue_yellow',
  },
  {
    title: 'red_green_yellow',
    img: 'https://common.xmslol.com/vooglam/relevant/color-block/three-tone/red_green_yellow.png',
    id: 'red_green_yellow',
  },
  {
    title: 'red_purple_yellow',
    img: 'https://common.xmslol.com/vooglam/relevant/color-block/three-tone/red_purple_yellow.png',
    id: 'red_purple_yellow',
  },
  {
    title: 'red_yellow_crystal',
    img: 'https://common.xmslol.com/vooglam/relevant/color-block/three-tone/red_yellow_crystal.png',
    id: 'red_yellow_crystal',
  },
  {
    title: 'white_purple_blue',
    img: 'https://common.xmslol.com/vooglam/relevant/color-block/three-tone/white_purple_blue.png',
    id: 'white_purple_blue',
  },
  {
    title: 'yellow_green_blue',
    img: 'https://common.xmslol.com/vooglam/relevant/color-block/three-tone/yellow_green_blue.png',
    id: 'yellow_green_blue',
  },
  {
    title: 'yellow_green_brown',
    img: 'https://common.xmslol.com/vooglam/relevant/color-block/three-tone/yellow_green_brown.png',
    id: 'yellow_green_brown',
  },
  {
    title: 'black_gray_tortoiseshell',
    img: 'https://common.xmslol.com/vooglam/relevant/color-block/moho/black_gray_tortoiseshell.jpg',
    id: 'black_gray_tortoiseshell',
  },
  {
    title: 'bright_light_gold',
    img: 'https://common.xmslol.com/vooglam/relevant/color-block/moho/bright_light_gold.jpg',
    id: 'bright_light_gold',
  },
  {
    title: 'bright_silver',
    img: 'https://common.xmslol.com/vooglam/relevant/color-block/moho/bright_silver.jpg',
    id: 'bright_silver',
  },
  {
    title: 'deep_brown',
    img: 'https://common.xmslol.com/vooglam/relevant/color-block/moho/deep_brown.jpg',
    id: 'deep_brown',
  },
  {
    title: 'pale_yellow_tortoiseshell',
    img: 'https://common.xmslol.com/vooglam/relevant/color-block/moho/pale_yellow_tortoiseshell.jpg',
    id: 'pale_yellow_tortoiseshell',
  },
  {
    title: 'pale_yellow',
    img: 'https://common.xmslol.com/vooglam/relevant/color-block/moho/pale_yellow.jpg',
    id: 'pale_yellow',
  },
  {
    title: 'rose_gold',
    img: 'https://common.xmslol.com/vooglam/relevant/color-block/moho/rose_gold.jpg',
    id: 'rose_gold',
  },
  {
    title: 'white_stripe',
    img: 'https://common.xmslol.com/vooglam/relevant/color-block/moho/white_stripe.jpg',
    id: 'white_stripe',
  },
  {
    title: 'wine_red',
    img: 'https://common.xmslol.com/vooglam/relevant/color-block/moho/wine_red.jpg',
    id: 'wine_red',
  },
  {
    title: 'yellow_brown_tortoiseshell_dark',
    img: 'https://common.xmslol.com/vooglam/relevant/color-block/moho/yellow_brown_tortoiseshell_dark.jpg',
    id: 'yellow_brown_tortoiseshell_dark',
  },
  {
    title: 'yellow_brown_tortoiseshell_light',
    img: 'https://common.xmslol.com/vooglam/relevant/color-block/moho/yellow_brown_tortoiseshell_light.jpg',
    id: 'yellow_brown_tortoiseshell_light',
  },
];

// 商品卡片类型
export const CARD_TYPE = {
  GOODS_LIST: 'GOODS_LIST' as const, // 常规样式，场景（镜框列表，搜索结果，猜你喜欢，镜框专题列表，环保专题，心愿单（非编辑），最近浏览， flash sale, tbg）
  CARD: 'CARD' as const, // 商品卡片整体有背景色， 场景（首页best seller，new arrival, trendbook）
  SMALL_SIZE: 'SMALL_SIZE' as const, // 小尺寸商品卡片， 场景（购物车活动推荐，购物车猜你喜欢，心愿单编辑模式，最近浏览编辑模式）
} as const;

export type CardTypeValue = (typeof CARD_TYPE)[keyof typeof CARD_TYPE];
